import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../services/config.service';
import { EditModeService } from '../../services/edit-mode.service';
import { IntendedUsageService } from '../../services/intended-usage-service';
import { LmsLoaderService } from '../../services/lms-loader.service';
import { LmsMenuService } from '../../services/lms-menu.service';
import { LmsModuleService } from '../../services/lms-module.service';
import { RouteChangePopupService } from '../../services/route-change-popup.service';
import { UtilService } from '../../services/util.service';
import { LmsBaseAppComponent } from '../base-app/lms-base-app.component';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { PopupService } from './../../../core/services/popup.service';
import { LocoIncidentService } from './../../services/loco-incident-service';


@Component({
  selector: 'lms-loco-update-int-usage',
  templateUrl: './lms-loco-update-int-usage.component.html',
  styleUrls: ['./lms-loco-update-int-usage.component.scss']
})
export class LmsLocoUpdateIntUsageComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  loco: LocoDetail;
  intendedLoco: LocoDetail;
  trainId: string;
  errorDialog = false; // To show error on Popup
  popupErrorMessage: string; // Pop Up Heading
  popUpServiceSubscription: any;
  viewIntUsagepopup: boolean;
  tabLevel: number;
  configData;

  constructor(protected configService: ConfigService,
    protected lmsMenuService: LmsMenuService,
    protected lmsModuleService: LmsModuleService,
    protected utilService: UtilService,
    protected editModeService: EditModeService,
    protected routeChangePopupService: RouteChangePopupService,
    protected popupService: PopupService,
    private intendedUsageService: IntendedUsageService, private appUtilityService: AppUtilityService,
    private locoIncidentService: LocoIncidentService,
    private lmsLoaderService: LmsLoaderService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.dialogBox;
  }

  ngOnInit() {
    this.intendedLoco = {};
    this.loco = {};
    this.popupErrorMessage = 'Update Intended Usage';
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });
  }

  checkSuccessOperation(opr: any) {
    if (opr && opr.operation === 'IntendedUsage' && opr.data) {
      this.intendedLoco = JSON.parse(JSON.stringify(opr.data));
      this.popupErrorMessage = 'Update Intended Usage';
      this.errorDialog = false;
      this.viewIntUsagepopup = true;
    }
  }

  public save() {
    this.lmsLoaderService.showLoader();
    if (this.intendedLoco) {
      if (this.intendedLoco.intendedUsgaeNoteRequired && (!this.intendedLoco.intendedUsageNote || (this.intendedLoco.intendedUsageNote && this.intendedLoco.intendedUsageNote.length === 0))) {
        this.lmsLoaderService.hideLoader();
        this.intendedLoco.isIntendedUsageNotError = true;
      } else {
        this.loco = JSON.parse(JSON.stringify(this.intendedLoco));
        if (this.loco) {
          let intendedNotes = '';
          if (this.loco.intendedUsageNote) {
            intendedNotes = this.loco.intendedUsageNote.trim().toUpperCase();
          }
          const updateIntendedUsage = {
            locoId: this.appUtilityService.formatLocomotiveId(this.loco.locomotiveIdentifier),
            currentAssignment: this.loco.currentAssignment,
            intendedUsageCode: this.loco.intendedUsageCode,
            intendedUsageReason: this.loco.intendedUsageReason,
            intendedUsageNote: intendedNotes
          };

          this.intendedUsageService.updateIntendedUsage(updateIntendedUsage).subscribe(
            (data: any) => {
              this.lmsLoaderService.hideLoader();
              if (this.appUtilityService.isNumeric(data.priorityCode)) {
                const pCode = parseInt(data.priorityCode, 10);
                if (pCode >= 1 && pCode <= 4) {
                  this.viewIntUsagepopup = false;
                  const operation = {
                    operation: 'updateIntendedSuccess',
                    message: data.messageText
                  };
                  this.popupService.setPopupOperation(operation);
                } else {
                  this.errorDialog = true;
                  this.popupErrorMessage = data.messageText;
                }
              }
            }, error => {
              this.lmsLoaderService.hideLoader();
              this.errorDialog = true;
              this.popupErrorMessage = error._body;
            }
          );
        }
      }
    }
  }

  hideDialog() {
    this.viewIntUsagepopup = false;
    this.loco = {};
    this.intendedLoco = {};
  }

  resetPageMode() {
    this.errorDialog = false;
    this.viewIntUsagepopup = false;
    this.loco = {};
    this.intendedLoco = {};
  }

  ngOnDestroy() {
    this.popUpServiceSubscription.unsubscribe();
  }

  setPageMode(setPageData) {
    super.setPageMode(setPageData);
    setTimeout(() => {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('intUsagePopup');
      this.appUtilityService.setFocusToFirstElement(`${setPageData.id}Dialog`);
    }, 20);

  }
}
